import React, {useState, useEffect, useContext} from 'react';
import Datepicker from 'react-datepicker';
import { parse } from 'date-fns';
import styled from 'styled-components';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { LabelText } from '../../components/Language/LabelText';
import PrevNextDate from '../../components/UI/Date/PrevNextDate';
import HeaderTitle from '../../hoc/HeaderTitle';
import { LanguageContext } from "../../containers/Language/LanguageProvider";
import {registerLocale, setDefaultLocale} from 'react-datepicker';
import './calendarrevenue.css';
import { enGB, fr, nl, de } from 'date-fns/locale';
import { RevenueCalendarContext } from '../context/RevenueCalendarProvider';

export default function CalendarRevenue(props) {
    const date = props.revenueDate && parse(props.revenueDate, "dd/MM/yyyy", new Date());
    const [revenueDate, setSelectedDate] = useState(date);
    const [highlightDatesByStatus, setHighlightDatesByStatus] = useState([]); 
    const localeList = [enGB, fr, nl, de];
    const languageContext = useContext(LanguageContext);

    const { setRawDate, setRawDateHandler } = useContext(RevenueCalendarContext);

    const dateChangeHandler = (changedDate) => {  
        if (changedDate) 
        {
          let oldDate = revenueDate;  
          setSelectedDate(changedDate);
          setRawDate();
          props.onDateChange(changedDate, oldDate); 
        } 
    }
    
    useEffect(()=> {
        const selectedLanguage = languageContext && languageContext.language;
        if(selectedLanguage) {
            const selectedLangId = parseInt(selectedLanguage.id);
            registerLocale(selectedLanguage.text, localeList[selectedLangId-1]);
            setDefaultLocale(selectedLanguage.text); 
        }
    }, [languageContext.language.id])

    
    useEffect(() => {
        setSelectedDate((parse(props.revenueDate, "dd/MM/yyyy", new Date())));
    }, [props.isDateChanged]);

    const getUnsubmittedContractDates = (unSubmittedDatesData) => {
        return unSubmittedDatesData.map(d=>parse(d.revenueDate, "dd/MM/yyyy", new Date()));
    }
    
    const getSubmittedContractDates = (submittedDatesData) => {
        return submittedDatesData.map(d=>parse(d.revenueDate, "dd/MM/yyyy", new Date()));
    }
    
    const getPartiallySubmittedContractDates = (partiallySubmittedDates) => {
        return partiallySubmittedDates.map(d=>parse(d.revenueDate, "dd/MM/yyyy", new Date()));
    }
    
    const submittedDates = props.statusWiseRevenueDates && props.statusWiseRevenueDates.submitted && 
                            props.statusWiseRevenueDates.submitted.length > 0 ? props.statusWiseRevenueDates.submitted 
                            : []; 
    const unSubmittedDates = props.statusWiseRevenueDates && props.statusWiseRevenueDates.unSubmitted && 
                            props.statusWiseRevenueDates.unSubmitted.length > 0 ? props.statusWiseRevenueDates.unSubmitted 
                            : [];     
    const partialSubmittedDates = props.statusWiseRevenueDates && props.statusWiseRevenueDates.partial && 
                            props.statusWiseRevenueDates.partial.length > 0 ? props.statusWiseRevenueDates.partial 
                            : [];         
    
    const highlightDatesByStatusData = [
        {
          "react-datepicker__day--highlighted-submitted": getSubmittedContractDates(submittedDates)
        },
        {
          "react-datepicker__day--highlighted-partial": getPartiallySubmittedContractDates(partialSubmittedDates)
        },
        {
          "react-datepicker__day--highlighted-unsubmitted": getUnsubmittedContractDates(unSubmittedDates)
        }
    ];
    
    const getAllStatusData = () => {
        let allContractStatusData = [];
        if(submittedDates && submittedDates.length > 0) {
            submittedDates.map(d=>allContractStatusData.push(d));
        }
        if (partialSubmittedDates && partialSubmittedDates.length > 0) {
            partialSubmittedDates.map(d=>allContractStatusData.push(d));
        }
        if (unSubmittedDates && unSubmittedDates.length > 0) {
            unSubmittedDates.map(d=>allContractStatusData.push(d));
        }
    
        return allContractStatusData;
    }
    
    useEffect(() => {
        if(props.statusWiseRevenueDates) {
          const allData = getAllStatusData();
          if(allData && allData.length > 0){
           setHighlightDatesByStatus(highlightDatesByStatusData);
          }
        }
    }, [props.statusWiseRevenueDates]);   

    
    const BottomContentHeaderTitle = styled.div`
    font-size: 1.1vw;
    line-height: 2vh;
    text-align: left;
    padding: 0.2vw 0 0.1vw 1.5vw;
    color: #fff;
    `;
    const BottomContentDate = styled.div`
    font-size: 1.1vw;
    line-height: 3vh;
    text-align: right;
    color: #fff;
    width: 5vw;
    padding: 0.2vw 1vw 0.3vw 0.5vw;
    margin-top: 0.5vw;
    `;

    return (
        <Container className="calendar-revenue-container">
            <Row className="calendar-revenue-row">
                <HeaderTitle>
                    <BottomContentHeaderTitle>
                        <LabelText tid="calendar_revenue" />
                    </BottomContentHeaderTitle>
                </HeaderTitle>
            </Row>
            <Row className="calendar-revenue-row">
                <Col className="calendar-revenue-col">
                    <BottomContentDate>
                        <LabelText tid="date" />
                    </BottomContentDate>
                </Col>
                <Col className="calendar-revenue-col-calendar-textbox">
                    {
                        props.revenueDate && <Datepicker className="form-control form-control-sm"
                            tabIndex={0}
                            showPopperArrow={false}
                            strictParsing={true}
                            enableTabLoop = {false}
                            dateFormat="dd/MM/yyyy"
                            onChangeRaw={(e) => setRawDateHandler(e)}
                            selected={revenueDate}
                            onChange={modifiedDate => dateChangeHandler(modifiedDate)}
                            minDate={props.minDate && parse(props.minDate, "dd/MM/yyyy", new Date())}
                            maxDate={props.maxDate && parse(props.maxDate, "dd/MM/yyyy", new Date())}
                            highlightDates={highlightDatesByStatus}
                        />
                    }
                </Col>
                <Col className="calendar-revenue-col-prev-next-date">
                    {
                        props.revenueDate && <PrevNextDate className="date-arrow-container"
                                                dateChangeHandler = {(e) => dateChangeHandler(e)} revenueDate={revenueDate}
                                                minDate ={props.minDate} maxDate={props.maxDate} />
                    }
                </Col>
            </Row>
            {props.revenueDate && <Row className="calendar-intake-book-row">               
                <Col className="revenue-calendar-dateFormat">
                    <div><span>(DD/MM/YYYY)</span></div>
                </Col>                
            </Row>}
            <Row className="calendar-revenue-row">
                <Col className="calendar-revenue-col-calendar">
                    {
                        props.revenueDate && <Datepicker className="form-control form-control-sm"
                            tabIndex={0}
                            title="Revenue date calendar"
                            inline
                            showPopperArrow={false}
                            strictParsing={true}
                            dateFormat="dd/MM/yyyy"
                            selected={revenueDate}
                            onChangeRaw={(e) => setRawDateHandler(e)}
                            showMonthDropdown={true}
                            showYearDropdown={true}
                            onChange={modifiedDate => dateChangeHandler(modifiedDate)}
                            minDate={props.minDate && parse(props.minDate, "dd/MM/yyyy", new Date())}
                            maxDate={props.maxDate && parse(props.maxDate, "dd/MM/yyyy", new Date())}
                            highlightDates={highlightDatesByStatus}
                        />
                    }
                </Col>
            </Row>
        </Container>
    );
}